import React, { ElementType } from 'react';
import { cn } from '@/lib/utils';
import type { ColorVariant } from '@/lib/colors';

interface GlassIconProps {
  icon: ElementType;
  variant?: ColorVariant | 'message' | 'meeting' | 'task' | 'prospect' | 'company' | 'warning' | 'error' | 'success' | 'info';
  size?: number;
  className?: string;
}

const variantStyles: Record<string, string> = {
  documentation: 'from-blue-400/30 to-blue-300/10 border-blue-400/20 text-blue-600 dark:text-blue-400',
  video: 'from-purple-400/30 to-purple-300/10 border-purple-400/20 text-purple-600 dark:text-purple-400',
  link: 'from-green-400/30 to-green-300/10 border-green-400/20 text-green-600 dark:text-green-400',
  blue: 'from-blue-400/30 to-blue-300/10 border-blue-400/20 text-blue-600 dark:text-blue-400',
  green: 'from-green-400/30 to-green-300/10 border-green-400/20 text-green-600 dark:text-green-400',
  purple: 'from-purple-400/30 to-purple-300/10 border-purple-400/20 text-purple-600 dark:text-purple-400',
  amber: 'from-amber-400/30 to-amber-300/10 border-amber-400/20 text-amber-600 dark:text-amber-400',
  red: 'from-red-400/30 to-red-300/10 border-red-400/20 text-red-600 dark:text-red-400',
  rose: 'from-rose-400/30 to-rose-300/10 border-rose-400/20 text-rose-600 dark:text-rose-400',
  indigo: 'from-indigo-400/30 to-indigo-300/10 border-indigo-400/20 text-indigo-600 dark:text-indigo-400',
  cyan: 'from-cyan-400/30 to-cyan-300/10 border-cyan-400/20 text-cyan-600 dark:text-cyan-400',
  info: 'from-blue-400/30 to-blue-300/10 border-blue-400/20 text-blue-600 dark:text-blue-400',
  success: 'from-green-400/30 to-green-300/10 border-green-400/20 text-green-600 dark:text-green-400',
  warning: 'from-amber-400/30 to-amber-300/10 border-amber-400/20 text-amber-600 dark:text-amber-400',
  error: 'from-red-400/30 to-red-300/10 border-red-400/20 text-red-600 dark:text-red-400',
  message: 'from-indigo-400/30 to-indigo-300/10 border-indigo-400/20 text-indigo-600 dark:text-indigo-400',
  meeting: 'from-purple-400/30 to-purple-300/10 border-purple-400/20 text-purple-600 dark:text-purple-400',
  task: 'from-cyan-400/30 to-cyan-300/10 border-cyan-400/20 text-cyan-600 dark:text-cyan-400',
  prospect: 'from-pink-400/30 to-pink-300/10 border-pink-400/20 text-pink-600 dark:text-pink-400',
  company: 'from-emerald-400/30 to-emerald-300/10 border-emerald-400/20 text-emerald-600 dark:text-emerald-400',
  default: 'from-slate-400/30 to-slate-300/10 border-slate-400/20 text-slate-600 dark:text-slate-400'
};

const GlassIcon = ({ icon: Icon, variant = 'default', size = 20, className }: GlassIconProps) => {
  const variantStyle = variantStyles[variant as string] || variantStyles.default;
  
  return (
    <div
      className={cn(
        'relative flex items-center justify-center',
        'w-10 h-10 rounded-xl',
        'bg-gradient-to-br backdrop-blur-md',
        'border shadow-lg shadow-black/5',
        'transform-gpu transition-all duration-200',
        'hover:scale-105 hover:shadow-xl',
        variantStyle,
        className
      )}
    >
      <Icon size={size} className="relative z-10" />
    </div>
  );
};

export default GlassIcon;
